// extracted by mini-css-extract-plugin
export var banner = "_0-0";
export var icon = "_0-1";
export var message = "_0-2";